import { useContext, useState } from 'react';
import FormField from '../../components/FormField/FormField';
import StepHeader from '../../components/Wizard/StepHeader';
import { clearSpaces, maskClearSpecialCharacters } from '../../utils/Masks';
import Button from '../../components/Button/Button';
import ButtonLabel from '../../components/Button/ButtonLabel';

import Alert from '../../components/Alert';
import { SignUpContext } from '../../data/SignUp/SignUpContext';
import RedirectSignIn from './RedirectSignIn';

export interface SignUpFirstNameProps {
  allowSkipStep?: boolean;
  updateData?: boolean;
  previousPath?: number | null;
  nextPath?: number | null;
  handleChangeStep(e: number): void;
  context: any;
}

export default function SignUpFirstName({
  nextPath,
  previousPath,
  handleChangeStep,
  context
}: SignUpFirstNameProps) {
  const [errorRequest, setErrorRequest] = useState('');

  const { register, trigger, errors, touchedFields, getValues } =
    useContext(SignUpContext);

  function controlBackPage() {
    if (previousPath == 0 || previousPath) handleChangeStep(previousPath);
  }

  window.onpopstate = () => {
    controlBackPage();
  };

  async function checkValidateFields() {
    const validateFullName = await trigger(['firstName']);

    return new Promise((resolve) => {
      const fixedFieldsValidated = validateFullName;
      resolve(fixedFieldsValidated);
    });
  }

  function nextStep() {
    checkValidateFields().then((response) => {
      if (response && nextPath) {
        handleChangeStep(nextPath);
      }
    });
  }

  return (
    <div className="card__section">
      <div className="card__top">
        <StepHeader
          title="Vamos criar sua conta"
          description="Para começar, precisamos saber um pouco sobre você."
        />

        <div className="form-group">
          <Alert
            message={errorRequest}
            errors={errors}
            onClose={setErrorRequest}
          />

          <FormField
            name="firstName"
            label="qual seu nome?"
            type="text"
            error={errors}
            touchedFields={touchedFields}
            onKeyUp={maskClearSpecialCharacters}
            onBlur={clearSpaces}
            register={register('firstName')}
            placeholder="apenas o primeiro nome"
            iconPrefix="personId"
          />
        </div>
      </div>

      <div className="button-group">
        <Button
          id="signup-name"
          full
          onClick={nextStep}
          disabled={!!errors?.firstName || !getValues('firstName')}
        >
          <ButtonLabel>continuar</ButtonLabel>
        </Button>

        <Button
          customColors="btn-ghost"
          aria-label="Voltar"
          onClick={controlBackPage}
        >
          <ButtonLabel>Voltar</ButtonLabel>
        </Button>

        <RedirectSignIn context={context} />
      </div>
    </div>
  );
}
